import {
  SimpleAnnouncementBar,
  type SimpleAnnouncementBarProps,
} from '@/components/AnnouncementBar'

const SimpleAnnouncementBarBlock = (props: SimpleAnnouncementBarProps) => (
  <SimpleAnnouncementBar {...props} />
)
export default SimpleAnnouncementBarBlock
